import cache from 'src/utils/cache';

// Primary: APP_VUE_CURRENT_VERSION from CI/CD (set during deployment)
// Fallback: APP_VERSION from quasar.config.cjs (read from version.txt - available locally)
const APP_VUE_CURRENT_VERSION = process.env.APP_VUE_CURRENT_VERSION?.toString() || process.env.APP_VERSION?.toString() || '0';
// Keep this literal for the same reason as LogoutUtil: this module is imported by
// early auth/settings chunks, so top-level CONSTANTS access can break Vue mount.
const APP_VERSION_KEY = 'APP_VERSION';

export const AppVersion = {
  setting_name : APP_VERSION_KEY,

  isRefershReq () {
    const saved_version = cache.methods.getDataByKey(this.setting_name);
    let refresh_required = false;
    if (!saved_version) {
      refresh_required = true;
    }
    if (APP_VUE_CURRENT_VERSION !== saved_version) {
      refresh_required = true;
    }
    return refresh_required;
  },

  updateVersion () {
    cache.methods.setDataToLocalStorage(this.setting_name, APP_VUE_CURRENT_VERSION);
  }
}
